import { FunctionComponent, useEffect, useState } from 'react'
import { ApiClient } from '@/types/ApiClient.ts'
import DaycareApiClientList from './daycareList/daycareList.tsx'
import ApiClientInformation from './apiClientInformation/apiClientInformation.tsx'
import { useLazyQuery } from '@apollo/client'
import { GET_API_CLIENT } from '@/modules/API/apiClient/getApiClient.ts'
import { Navigate } from 'react-router-dom'
import Loading from '@/components/Loading/Loading.tsx'

interface ApiClientProfileArgs {
    id: number
    backToList: () => void
}

const ApiClientProfile: FunctionComponent<ApiClientProfileArgs> = ({ id, backToList }: ApiClientProfileArgs) => {
    const [apiClient, setApiClient] = useState<ApiClient | null>(null)

    const [getApiClient, { loading: loadingApiClient, data: dataApiClient, refetch }] = useLazyQuery(GET_API_CLIENT)

    useEffect(() => {
        getApiClient({
            variables: {
                id: id
            }
        })
    }, [id])

    useEffect(() => {
        if (dataApiClient) {
            setApiClient(dataApiClient.getApiClient)
        }
    }, [dataApiClient])

    return (
        <>
            {loadingApiClient && <Loading />}
            {apiClient ? (
                <>
                    <ApiClientInformation apiClient={apiClient} refetch={refetch} backToList={backToList} />
                    <DaycareApiClientList id={apiClient.id} apiClientDaycares={apiClient.daycares} refetch={refetch} />
                </>
            ) : (
                <Navigate to={'/settings#apiClient'} />
            )}
        </>
    )
}

export default ApiClientProfile
